import * as tslib_1 from "tslib";
import { mapHash, DateComponent } from '@fullcalendar/core';
import { DayGridSlicer } from '@fullcalendar/daygrid';
import { VResourceSplitter, VResourceJoiner } from '@fullcalendar/resource-common';
var ResourceDayGrid = /** @class */ (function (_super) {
    tslib_1.__extends(ResourceDayGrid, _super);
    function ResourceDayGrid(dayGrid) {
        var _this = _super.call(this, dayGrid.el) || this;
        _this.splitter = new VResourceSplitter();
        _this.slicers = {};
        _this.joiner = new ResourceDayGridJoiner();
        _this.dayGrid = dayGrid;
        return _this;
    }
    ResourceDayGrid.prototype.firstContext = function (context) {
        context.calendar.registerInteractiveComponent(this, {
            el: this.dayGrid.el
        });
    };
    ResourceDayGrid.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.context.calendar.unregisterInteractiveComponent(this);
    };
    ResourceDayGrid.prototype.render = function (props, context) {
        var _this = this;
        var dayGrid = this.dayGrid;
        var dateProfile = props.dateProfile, resourceDayTable = props.resourceDayTable, nextDayThreshold = props.nextDayThreshold;
        var splitProps = this.splitter.splitProps(props);
        this.slicers = mapHash(splitProps, function (split, resourceId) {
            return _this.slicers[resourceId] || new DayGridSlicer();
        });
        var slicedProps = mapHash(this.slicers, function (slicer, resourceId) {
            return slicer.sliceProps(splitProps[resourceId], dateProfile, nextDayThreshold, context.calendar, dayGrid, resourceDayTable.dayTable);
        });
        dayGrid.allowAcrossResources = resourceDayTable.dayTable.colCnt === 1;
        dayGrid.receiveProps(tslib_1.__assign({}, this.joiner.joinProps(slicedProps, resourceDayTable), { dateProfile: dateProfile, cells: resourceDayTable.cells, isRigid: props.isRigid }), context);
    };
    ResourceDayGrid.prototype.buildPositionCaches = function () {
        this.dayGrid.buildPositionCaches();
    };
    ResourceDayGrid.prototype.queryHit = function (positionLeft, positionTop) {
        var rawHit = this.dayGrid.positionToHit(positionLeft, positionTop);
        if (rawHit) {
            return {
                component: this.dayGrid,
                dateSpan: {
                    range: rawHit.dateSpan.range,
                    allDay: rawHit.dateSpan.allDay,
                    resourceId: this.props.resourceDayTable.cells[rawHit.row][rawHit.col].resource.id
                },
                dayEl: rawHit.dayEl,
                rect: {
                    left: rawHit.relativeRect.left,
                    right: rawHit.relativeRect.right,
                    top: rawHit.relativeRect.top,
                    bottom: rawHit.relativeRect.bottom
                },
                layer: 0
            };
        }
    };
    return ResourceDayGrid;
}(DateComponent));
export default ResourceDayGrid;
var ResourceDayGridJoiner = /** @class */ (function (_super) {
    tslib_1.__extends(ResourceDayGridJoiner, _super);
    function ResourceDayGridJoiner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceDayGridJoiner.prototype.transformSeg = function (seg, resourceDayTable, resourceI) {
        var colRanges = resourceDayTable.computeColRanges(seg.firstCol, seg.lastCol, resourceI);
        return colRanges.map(function (colRange) {
            return tslib_1.__assign({}, seg, colRange, { isStart: seg.isStart && colRange.isStart, isEnd: seg.isEnd && colRange.isEnd });
        });
    };
    return ResourceDayGridJoiner;
}(VResourceJoiner));
